var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsHomeDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/home-dollar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 18H4.66645C3.68867 18 2.88867 17.2 2.88867 16.2222V8.22222L9.99978 2L17.1109 8.22222V16.2222C17.1109 17.2 16.3109 18 15.3331 18H12M8 18V12H12V18M8 18H12",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHomeDollar);
export default __webpack_public_path__ + "static/media/icons-home-dollar.54dd2cabbe4ef6115d20eaad576c35e4.svg";
export { ForwardRef as ReactComponent };